import {
  LISTA_VERIFICACAO_IDENTIDADE,
  LISTA_VERIFICACAO_IDENTIDADE_SUCESSO,
  LISTA_VERIFICACAO_IDENTIDADE_ERRO,
  APROVA_VERIFICACAO_IDENTIDADE,
  APROVA_VERIFICACAO_IDENTIDADE_SUCESSO,
  REPROVA_VERIFICACAO_IDENTIDADE,
  REPROVA_VERIFICACAO_IDENTIDADE_SUCESSO,
  VERIFICACAO_IDENTIDADE_ERRO,
} from 'constants/ActionTypes';

export const listaVerificacaoIdentidade = (pagina = 1, tamanhoPagina = 20, status = 'PENDENTE') => ({
  type: LISTA_VERIFICACAO_IDENTIDADE,
  payload: { pagina, tamanhoPagina, status },
});

export const listaVerificacaoIdentidadeSucesso = (data) => ({
  type: LISTA_VERIFICACAO_IDENTIDADE_SUCESSO,
  payload: data,
});

export const listaVerificacaoIdentidadeErro = (mensagem) => ({
  type: LISTA_VERIFICACAO_IDENTIDADE_ERRO,
  payload: mensagem,
});

export const aprovaVerificacaoIdentidade = (id) => ({
  type: APROVA_VERIFICACAO_IDENTIDADE,
  payload: { id },
});

export const aprovaVerificacaoIdentidadeSucesso = () => ({
  type: APROVA_VERIFICACAO_IDENTIDADE_SUCESSO,
});

export const reprovaVerificacaoIdentidade = (id, motivo) => ({
  type: REPROVA_VERIFICACAO_IDENTIDADE,
  payload: { id, motivo },
});

export const reprovaVerificacaoIdentidadeSucesso = () => ({
  type: REPROVA_VERIFICACAO_IDENTIDADE_SUCESSO,
});

export const verificacaoIdentidadeErro = (mensagem) => ({
  type: VERIFICACAO_IDENTIDADE_ERRO,
  payload: mensagem,
});
